// extracted by mini-css-extract-plugin
module.exports = {"navBar":"FooterNavBar_navBar__3S_sz","navItem":"FooterNavBar_navItem__gzOaf","navLink":"FooterNavBar_navLink__1QxxG"};